/*
 * @Author: 硪要滴幸福丶 542709122@qq.com
 * @Date: 2023-02-07 11:47:54
 * @LastEditors: 硪要滴幸福丶 542709122@qq.com
 * @LastEditTime: 2024-02-01 11:07:50
 * @FilePath: \vueproject\src\api\payMG.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: 硪要滴幸福丶 542709122@qq.com
 * @Date: 2023-02-07 11:47:54
 * @LastEditors: 硪要滴幸福丶 542709122@qq.com
 * @LastEditTime: 2023-02-12 10:59:24
 * @FilePath: \vueproject\src\api\payMG.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import { req,reqjson } from './axiosFun';

/**
 * 支付配置信息
 **/
// 支付配置信息-获取支付配置信息列表
export const KamiFindPageAllList = (params) => { return req("get", "/cyc/km/findPageAll?page=" + params.page + "&size=" + params.size + "&str=" + params.kamiNo)};
export const KamiSave = (params) => { return reqjson("post", "/cyc/km/save?num="+params.num, params) };
export const KamiDel = (params) => { return reqjson("post", "/cyc/km/del", params) };
export const logPageAllList = (params) => { return req("get", "/cyc/log/findPageAll?page=" + params.page + "&size=" + params.size + "&str=" + params.kamiNo)};
export const userPageAllList = (params) => { return req("get", "/cyc/user/findPageAll?page=" + params.page + "&size=" + params.size + "&str=" + params.kamiNo)};
export const userUpdate = (params) => { return reqjson("post", "/cyc/user/update?cishu="+params.cishu,params) };
export const userDel = (params) => { return reqjson("get", "/cyc/user/del") };
/**
 * 支付配置 
 **/
// 支付配置-获取支付配置列表
export const ConfigList = (params) => { return req("post", "/api/Config/list", params) };
// 支付配置-保存支付配置
export const ConfigSave = (params) => { return req("post", "/api/Config/save", params) };
// 支付配置-删除支付配置
export const ConfigDelete = (params) => { return axios.delete("/api/Config/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 订单管理-交易订单 
 **/
// 交易订单-获取交易订单列表
export const OrderList = (params) => { return req("post", "/api/Order/list", params) };
// 交易订单-s删除交易订单
export const OrderDelete = (params) => { return axios.delete("/api/Order/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 交易订单-交易订单退款
export const OrderRefund = (params) => { return req("post", "/api/Order/refund", params) };


// WEBPACK FOOTER //
// ./src/api/payMG.js